import useDense from './useDense';
import { useEffect, useState } from 'react';
import { QueryKeys } from '~/api/queryKeys';
import { Users } from '~/api/scheme';
import useCurrentUser from '../useCurrentUser';
import useActiveColumns from './useActiveColumns';
import { useQuery } from 'react-query';

type Args = {
  scope: UISettingsScope;
};

export type UserSettingsProps = {
  activeColumns: string[];
  dense: boolean;
  onChangeActiveColumns: (column: string[], value: boolean) => void;
  onChangeDense: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setShowMask: (value: boolean) => void;
  showMaskSettings: boolean;
  resetToDefault: () => void;
};

const useUISettings = (args: Args): UserSettingsProps => {
  const { scope } = args;
  const { currentUser } = useCurrentUser();
  const [showMaskSettings, setShowMaskSettings] = useState<boolean>(true);

  const setShowMask = (value: boolean) => {
    setShowMaskSettings(value);
  };

  const { data: settingsData, refetch: refetchSettings } = useQuery(
    QueryKeys.uiSettings(Number(currentUser?.id)),
    () => Users.UISettings.show({ user_id: Number(currentUser?.id), mask_user: showMaskSettings })
  );

  useEffect(() => {
    refetchSettings();
  }, [showMaskSettings, refetchSettings]);

  const uiSettings = settingsData?.data && settingsData?.data[scope];
  const savedDense = uiSettings?.dense;
  const savedColumns = uiSettings?.columns;

  const { dense, onChangeDense } = useDense({ savedDense, showMaskSettings, scope });
  const { activeColumns, onChangeActiveColumns, resetToDefault } = useActiveColumns({
    scope,
    savedColumns,
    showMaskSettings,
  });

  return {
    activeColumns,
    dense,
    onChangeActiveColumns,
    onChangeDense,
    setShowMask,
    showMaskSettings,
    resetToDefault,
  };
};

export default useUISettings;
